import React from 'react';

const addPrintClass = () => {
  const quoteOptionCards = document.querySelectorAll('.cmp-quote-option__card');
  if (quoteOptionCards.length > 0) {
    quoteOptionCards[quoteOptionCards.length - 1].classList.add('cmp-quote-option__card--border-bottom');
  }
};

const PrintQuote = () => (
  <button
    type="button"
    className="cmp-cta-link cmp-cta-link--inverted cmp-print-quote"
    onClick={() => {
      addPrintClass();
      window.print();
    }}
  >
    <span>
      Print Quote
    </span>
  </button>
);

export { PrintQuote };
